import {
  DEFAULT_AMOUNT,
  DEFAULT_PURPOSE,
  DEFAULT_TERM,
} from 'lib/constants/offerFilter';
import { DEFAULT } from 'lib/constants/registrationRoutes';
import { IPgPageBuilderFields } from 'types/generated/contentful';

export const getDefaultPageConfig = () => {
  return {
    term: DEFAULT_TERM,
    amount: DEFAULT_AMOUNT,
    purpose: DEFAULT_PURPOSE,
    includeSEO: false,
    markupSchema: 'article',
    minimizeHeaderAndFooter: false,
    registrationRoute: DEFAULT,
    isMainSEAPage: false,
  };
};

// Todo: after migration to separate fields, this can be removed
export interface IContentfulPageConfig {
  userTerm: string;
  includeSEO: boolean;
  userAmount: string;
  userPurpose: string;
  markupSchema: string;
  minimizeHeaderAndFooter: boolean;
  userOverrideDefaultTerm: boolean;
  userOverrideDefaultAmount: boolean;
  userOverrideDefaultPurpose: boolean;
  registrationRoute: string;
  userOverrideDefaultRegistrationRoute: boolean;
}

export const getContentfulPageConfig = (
  page: IPgPageBuilderFields,
): Partial<IPageConfig> => {
  const contentfulPageConfig = {
    minimizeHeaderAndFooter: page.minimizeHeaderAndFooter,
    markupSchema: page.markupSchema,
    includeSEO: page.indexPage,
    registrationRoute: page.overrideRegistrationRoute,
  } as Partial<IPageConfig>;

  const term = page.overrideTerm && parseInt(page.overrideTerm);
  if (term && typeof term === 'number') {
    contentfulPageConfig.term = term as number;
  }

  const amount = page.overrideAmount && parseInt(page.overrideAmount);
  if (amount && typeof amount === 'number') {
    contentfulPageConfig.amount = amount as number;
  }

  if (page.overridePurpose && page.overridePurpose !== 'default') {
    contentfulPageConfig.purpose = page.overridePurpose;
  }

  return contentfulPageConfig as Partial<IPageConfig>;
};

export const getCustomFormConfig = (page: IPgPageBuilderFields) => {
  const { url } = page;

  if (url === '/lp/kreditvergleich-dac/') {
    return 'ddf_marketing';
  }

  if (url === '/lp/kreditvergleich-dac-hard/') {
    return 'ddf_sem_hard_dac';
  }

  return '';
};

export const getUrlPageConfig = (page: IPgPageBuilderFields) => {
  const { url } = page;

  // These are special and get a separate legal text footer.
  // We should think about porting this flag into Contentful.
  const mainSEAPageUrls = [
    '/lp/kreditvergleich/',
    '/lp/kreditvergleich-dac/',
    '/lp/autokredit/',
    '/lp/banken/',
    '/lp/umschuldung/',
    '/lp/online-kreditvergleich/',
    '/lp/kredite/',
    '/lp/autokredit-direkt/',
    '/lp/umschuldung-direkt/',
    '/lp/test/', // This is a test page just to have it the same as SEA
  ];

  const isMainSEAPage = mainSEAPageUrls.includes(url);

  return {
    isMainSEAPage,
  };
};

export interface IPageConfig {
  amount: number;
  term: number;
  purpose: string;
  includeSEO: boolean;
  markupSchema: string;
  minimizeHeaderAndFooter: boolean;
  registrationRoute: string;
  isMainSEAPage: boolean;
  formConfig?: string;
}

/**
 * Extracts the page config from fields on the given page and merges it
 * with the defaults and potential url overrides.
 * @param page
 * @returns
 */
export const getPageConfig = (page: IPgPageBuilderFields) => {
  const defaultPageConfig = getDefaultPageConfig();
  const contenfulPageConfig = getContentfulPageConfig(page);
  const urlPageConfig = getUrlPageConfig(page);

  const mergedPageConfig = {
    ...defaultPageConfig,
    ...contenfulPageConfig,
    ...urlPageConfig,
  };

  return mergedPageConfig as IPageConfig;
};
